import React from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import { TableCell } from '@mui/material';
import * as S from './styled';

const EMPTY = {};
const SimpleTable = ({ header, rows, stickyHeader, bodyOptions = EMPTY, headOptions = EMPTY }) => (
  <Table stickyHeader={stickyHeader} size="small" aria-label="customized table">
    <S.TableHead>
      <S.TableRow>
        {header?.map((item, i) => (
          <TableCell key={typeof item === 'string' ? item : i} style={headOptions}>
            {item || ''}
          </TableCell>
        ))}
      </S.TableRow>
    </S.TableHead>
    <S.TableBody>
      {rows?.map((row, idx) => (
        <S.TableRow key={row?.id || idx}>
          {Object.keys(row).map(key => (
            <TableCell key={key} style={bodyOptions}>
              {row[key] || ''}
            </TableCell>
          ))}
        </S.TableRow>
      ))}
    </S.TableBody>
  </Table>
);

SimpleTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  header: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  stickyHeader: PropTypes.bool,
  bodyOptions: PropTypes.object,
  headOptions: PropTypes.object
};

export default SimpleTable;
